/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ brandName: NonNullable<unknown> }} Marketing_Section_Get_OnyxInputs */

const en_marketing_section_get_onyx = /** @type {(inputs: Marketing_Section_Get_OnyxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Get ${i?.brandName}`)
};

const es_marketing_section_get_onyx = /** @type {(inputs: Marketing_Section_Get_OnyxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Consigue ${i?.brandName}`)
};

const fr_marketing_section_get_onyx = /** @type {(inputs: Marketing_Section_Get_OnyxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Obtenir ${i?.brandName}`)
};

/**
* | output |
* | --- |
* | "Get {brandName}" |
*
* @param {Marketing_Section_Get_OnyxInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_section_get_onyx = /** @type {((inputs: Marketing_Section_Get_OnyxInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Section_Get_OnyxInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_section_get_onyx(inputs)
	if (locale === "es") return es_marketing_section_get_onyx(inputs)
	return fr_marketing_section_get_onyx(inputs)
});